<template>
	<v-text-field
		class="form__field"
		v-model="localValue"
		:items="options"
		:rules="validationRules"
		:label="label"
		:type="type"
		:placeholder="placeholder"
	/>
</template>

<script>

export default {
	props: {
		value: String,
		label: String,
		options: Array,
		placeholder: String,
		required: {
			type: Boolean,
			default: true
		},
		email: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		validationRules() {
			const rules = [];

			if (this.required) {
				rules.push(v => !!v || this.$t("isRequired", { label: this.label }))
			}

			if (this.email) {
				const emailPattern = /.+@.+/
				rules.push(v => emailPattern.test(v) || this.$t("emailAddSign"))
			}

			return rules
		},
		localValue: {
			get() {return this.value},
			set(localValue) { this.$emit('input', localValue)}
        },
		type() {
			return this.email ? 'email' : 'text'
		}
	},
	i18n: {
		messages: {
			nl: {
				isRequired: "{label} is een verplicht veld",
				emailAddSign: 'E-mail adres moet het "@" symbool bevatten.'
			},
			en: {
				isRequired: "{label} is a required field",
				emailAddSign: "Email addresses should contain the \"@\" symbol.",
			}
		}
	}
}
</script>
